export const getDevicesList = (state) => state.admin.devices.devicesList.list
export const getDevicesCount = (state) => state.admin.devices.devicesList.totalCount
export const getDevicesSnapshot = (state) => state.admin.devices.snapshot
